export default "__VITE_ASSET__77b7b9b5__"